import getGeocodeData from "./geocodeData";
import getDistance from "./getDisctance";

const findNearestLocations = (locations, lat, lng) => {
  let minDistance = null;
  const nearestLocation = [];
  const nearestLocationsWithinMi = [];

  locations.forEach((location) => {
    const distance = getDistance(lat, lng, location.lat, location.lng);
    location.distance = distance;

    if (distance <= 10) {
      nearestLocationsWithinMi.push(location);
    }

    if (nearestLocationsWithinMi.length === 0) {
      if (minDistance === null || distance < minDistance) {
        minDistance = distance;
        nearestLocation.length = 0; // Clear the array before adding new nearest locations
      }
  
      if (distance <= minDistance) {
        nearestLocation.push(location);
      }
    }
  });

  //sort by distance
  if (nearestLocationsWithinMi.length) {
    nearestLocationsWithinMi.sort(function(a, b) {
      if (a.distance < b.distance) return -1;
      if (a.distance > b.distance) return 1;
      return 0;
    });
  }

  const nearestLocationData = nearestLocationsWithinMi.length === 0 ? nearestLocation : nearestLocationsWithinMi;

  return nearestLocationData;
};

const fetchLocations = async (api, page_id) => {
    const response = await fetch(`/wp-json/udp/v1/locations/${page_id}/${api}`);
  
    if (!response.ok) {
      throw Error(response.statusText);
    }
  
    const data = await response.json(); 

    if (data.length === 0) {
      // Fetch fallback data
      const fallbackResponse = await fetch(`/wp-json/udp/v1/locations/${page_id}/null`);
  
      if (!fallbackResponse.ok) {
        throw Error(fallbackResponse.statusText);
      }
  
      const locations = await fallbackResponse.json();
      const geocodeResults = await getGeocodeData(api);
      
      if (geocodeResults.length === 0) {
        return geocodeResults;
      }

      const lat = geocodeResults[0].geometry.location.lat();
      const lng = geocodeResults[0].geometry.location.lng();

      const nearestLocationsData = findNearestLocations(locations, lat, lng);
  
      return nearestLocationsData;
    }
  
    return data;
  };
  
  export default fetchLocations;
  



